/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from 'js/lib/react-router';
import { useParams } from 'js/lib/useRouter';

import { breakpoints } from '@coursera/cds-core';

import { getHomeLink } from 'bundles/enterprise-admin-navigation/utils/AdminNavigationUtils';
import CourseraLogo from 'bundles/page/components/CourseraLogo';

const DEFAULT_NAVBAR_HEIGHT = 60;

type Props = {
  navHeight?: number;
  leftChildren: React.ReactNode;
  rightChildren: React.ReactNode;
  style?: React.CSSProperties;
};

const CourseraHeader: React.FC<Props> = ({
  rightChildren,
  leftChildren,
  navHeight = DEFAULT_NAVBAR_HEIGHT,
  style,
  ...props
}) => {
  const params = useParams();
  const styles = {
    navBar: css`
      background: var(--cds-color-white-0);
      box-shadow: 0 1px 0 0 var(--cds-color-grey-50);
      padding-left: 16px;
      display: flex;
    `,
    logo: css`
      ${breakpoints.up('sm')} {
        margin-right: 24px;
        margin-left: 24px;
      }

      display: flex;
      align-items: center;
    `,
  };
  const dynamicStyles = {
    navBar: {
      height: `${navHeight}px`,
    },
  };
  const mergedStyles = {
    ...style,
    ...dynamicStyles.navBar,
  };
  return (
    <div css={styles.navBar} style={mergedStyles} {...props}>
      <div css={styles.logo}>
        <Link to={getHomeLink(params)} css={{ textDecoration: 'none' }} data-testid="coursera-logo">
          <CourseraLogo
            css={css`
              width: 127px;
              height: 32px;
            `}
          />
        </Link>
      </div>
      <div css={{ flex: 1 }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: '100%', flex: 1 }}>
          {leftChildren}
          {rightChildren}
        </div>
      </div>
    </div>
  );
};
export default CourseraHeader;
